module.exports = __webpack_public_path__ + "static/media/algarrobo.f6a32b37.jpg";